module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3r2r6r9r-7c3f41b31a6ef710517a47375752c78e.svg";